import commonMixin from './_common';

// 画像なしファイル名
const NO_IMAGE = 'common/magnet_common_noimg.png';

/**
 * 商品画像・詳細画像を扱うためのmixin
 */
export default {
    data() {
        return {
            arg_image: null,
            arg_page_dir: null,
            arg_edit_id_dir: null,
        };
    },
    mixins: [
        commonMixin,
    ],
    computed: {
        /**
         * 使用する画像データの選定
         * (propsから拾うのか、mixinのdataから拾うのか)
         */
        // 画像パス
        imageInfo: function () {
            return (typeof this.image !== 'undefined') ? this.image : this.arg_image;
        },
        // ページタイプ(build_store/item/custom_page)
        pageDirInfo: function () {
            return (typeof this.page_dir !== 'undefined') ? this.page_dir : this.arg_page_dir;
        },
        // エディットID
        editIdInfo: function () {
            return (typeof this.edit_id_dir !== 'undefined') ? this.edit_id_dir : this.arg_edit_id_dir;
        },

        /**
         * 画像パスの生成・判定
         */
        // プレビュー表示用にパスを整えてから使用する
        preview: function () {
            // 空だったらノーイメージ
            if (!this.hasImage) {
                return this.config.storage_path + '/' + NO_IMAGE;
            }
            // ファイル名だけでなかったらそのまま使用する
            if (this.isIncludePath(this.imageInfo)) {
                return this.imageInfo;
            }
            // 共通ファイルか
            if (this.isCommonFile(this.imageInfo)) {
                return this.config.storage_path + '/' + this.imageInfo;
            }
            return this.storageImage;
        },
        // storageに保存されている画像のURL(this.imageInfo+ユーザー情報から組み立て)
        storageImage: function () {
            return [
                this.config.storage_path,
                'users',
                this.config.user.shop_id,
                'images',
                this.pageDirInfo,
                this.editIdInfo,
                this.imageInfo
            ].join('/');
        },
        // 画像登録の有無
        hasImage: function () {
            if (this.imageInfo === null || this.imageInfo.length === 0) {
                return false;
            }
            return true;
        },
    },
    methods: {
        // 共通画像ファイルか(common/xxx.jpg)のようにディクレトリを含んでいる場合
        isCommonFile: function (file) {
            return new RegExp('^.*?/.+$').test(file);
        },
        /**
         * URLがパス情報を含むか否か
         * 1. http:// または https:// で始まる
         * 2. 末尾にファイル名がある( /... となっている)
         * ファイル名が拡張子を持つことの確認については、URL先で動的生成される画像なども考慮して省略。
         * チェックする場合は '^https?://.+/[^.]+\\..+$'
         */
        isIncludePath: function (url) {
            return new RegExp('^https?://.+/.+$').test(url);
        },
        /**
         * プレビュー画像パスを取得する
         * (必要な画像データはpropsか引数から参照。)
         *
         * @param {Object} data
         */
        getPreviewImagePath: function (image, editDir, pageDir) {

            // 画像情報が引き渡された場合はそちらを採用
            if (typeof image !== 'undefined') {
                this.arg_image       = image;
                this.arg_edit_id_dir = editDir;
                this.arg_page_dir    = pageDir;
            }

            return this.preview + '?' + Date.now();
        },
    }
};